import { NewExamineeStepNames } from "../../store/newExamineeSlice";
import { BodyHeader } from "./BodyHeader";
import { ExamineeAssignedToComponent } from "./ExamineeAssignedTo";
import { ContactInfo } from "./ExamineeContactInfo";
import { ExamineeDetailsForm } from "./ExamineeDetails";

export const NewAssessmentBody = ({ currentStep }: NewAssessmentBodyProps): JSX.Element => {
    return (
        <div className="is-flex is-flex-direction-column is-justify-content-center">
            <BodyHeader />
            {currentStep === NewExamineeStepNames.ContactInfo && <ContactInfo />}
            {currentStep === NewExamineeStepNames.Details && <ExamineeDetailsForm />}
            {currentStep === NewExamineeStepNames.AssignedTo && <ExamineeAssignedToComponent />}
        </div>
    );
};

interface NewAssessmentBodyProps {
    currentStep: NewExamineeStepNames;
}
